import { Button, Typography } from 'antd';

const { Text } = Typography;

interface Props {
  errorCode?: string;
  onClose: () => void;
}

const PDFErrorModal = ({ errorCode, onClose }: Props) => (
  <div className="flex flex-col text-center">
    <Text className="mb-2 text-base font-bold">Download Request Unsuccessful</Text>
    <div className="mb-4 flex flex-col">
      <Text className="text-sm">
        The file cannot be retrieved at this moment.
        <br />
        Please try again later.
      </Text>
      <br />
      <Text className="text-sm">If problem persists, please contact us at</Text>
      <Text className="text-sm">
        <a className="font-semibold text-theme-600" href="tel:1800 2254 482">
          1800 2254 482
        </a>{' '}
        or{' '}
        <a className="font-semibold text-theme-600" href="mailto:contact_us@healthhub.sg">
          contact_us@healthhub.sg.
        </a>
      </Text>
      {!!errorCode && <Text className="text-sm">({errorCode})</Text>}
    </div>
    <div className="flex justify-center">
      <Button
        className="mb-2 h-12 w-3/4 rounded-lg bg-theme-700 text-center font-semibold text-white"
        htmlType="submit"
        onClick={onClose}
        type="primary"
      >
        <span className="text-white">Close</span>
      </Button>
    </div>
  </div>
);

export default PDFErrorModal;
